module.exports = __webpack_public_path__ + "img/snv-townsfolk.83cf9a72.png";